import req from "@/assets/js/axios"

export default {
    // 我的任务
    getAssignSubmits: (params) => {
        return req.apiAxios('POST', '/assignSubmit/assignSubmitController/whale-security/getAssignSubmits', params)
    },
    //添加学生认证
    saveOrSubmitStudent: (params) => {
        return req.apiAxios('POST', '/business/student/bStudentController/whale-security/saveOrSubmitStudent', params)
    },
    //查询学生认证
    getFrontStudents: (params) => {
        return req.apiAxios('POST', '/student/studentController/getFrontStudents', params)
    },
    //教师管理下的学生认证列表
    getStudents: (params) => {
        return req.apiAxios('POST', '/business/student/bStudentController/whale-security/getStudents', params)
    },
    //教师审核学生认证的操作
    approvalBackStudent: (params) => {
        return req.apiAxios('POST', '/business/student/bStudentController/whale-security/approvalBackStudent', params)
    },
    //查询毕设作品
    teachergetOpus: (params) => {
        return req.apiAxios('POST', '/business/opus/BOpusController/getOpus', params)
    },
    //教师审核学生毕设作品
    approvalByTeacherOpus: (params) => {
        return req.apiAxios('POST', '/business/opus/BOpusController/whale-security/approvalByTeacherOpus', params)
    },
     //学校下的所有学生
     getAllStudent: (params) => {
        return req.apiAxios('POST', '/student/studentController/getList', params)
    },
    //添加老师认证
    saveOrSubmitTeacher: (params) => {
        return req.apiAxios('POST', '/business/teacher/bTeacherController/whale-security/saveOrSubmitTeacher', params)
    },
    //查询老师认证
    getFrontTeachers: (params) => {
        return req.apiAxios('POST', '/teacher/teacherController/getFrontTeachers', params)
    },
    //学校管理下的老师认证列表
    getTeacherManagerList: (params) => {
        return req.apiAxios('POST', '/business/teacher/bTeacherController/whale-security/getTeacher', params)
    },
    //学校审核教师认证的操作
    approvalBackTeacher: (params) => {
        return req.apiAxios('POST', '/business/teacher/bTeacherController/whale-security/approvalBackTeacher', params)
    },
    //添加学校认证
    saveOrSubmitSchool: (params) => {
        return req.apiAxios('POST', '/business/school/bSchoolController/whale-security/saveOrSubmitSchool', params)
    },
    //查询学校认证
    getFrontSchools: (params) => {
        return req.apiAxios('POST', '/school/schoolController/getFrontSchools', params)
    },
    //查询学校列表
    getSchoolsList: (params) => {
        return req.apiAxios('POST', '/school/schoolController/getList', params)
    },
    //查询学校列表
    getTeacherList: (params) => {
        return req.apiAxios('POST', '/teacher/teacherController/getList', params)
    },
    //处理记录
    getExamines: (params) => {
        return req.apiAxios('POST', '/host/examine/ExamineController/getExamines', params)
    },
    //拓展
    getFrontExtends: (params) => {
        return req.apiAxios('POST', '/extend/extendController/getFrontExtends', params)
    },
    // 更新作品信息
    updateOpus: (params) => {
        return req.apiAxios("POST", '/opus/OpusController/whale-security/updateOpus', params)
    },
    // 修改作品权限（前台）
    updateOpusPermission: (params) => {
        return req.apiAxios("POST", '/business/opus/BOpusController/whale-security/updateOpusPermission', params)
    },
    // 新增展会
    releaseExhibition: (params) => {
        return req.apiAxios("POST", '/business/exhibition/bExhibitionController/whale-security/releaseExhibition', params)
    },
    // 展会-添加作品
    createSchoolOpusExhibition: (params) => {
        return req.apiAxios("POST", '/opusExhibition/opusExhibitionController/whale-security/createSchoolOpusExhibition', params)
    },
     // 展会-移除作品
     deleteSchoolOpusExhibitionById: (params) => {
        return req.apiAxios("POST", '/opusExhibition/opusExhibitionController/whale-security/deleteSchoolOpusExhibitionById', params)
    },
     // 展会-可添加作品列表
     getOpusByExhibition: (params) => {
        return req.apiAxios("POST", '/business/opus/BOpusController/getOpusByExhibition', params)
    },
    // 修改学校信息
    updateSchool: (params) => {
        return req.apiAxios("POST", '/business/school/bSchoolController/whale-security/updateSchool', params)
    },
     // 更新小程序轮播图
     updateViewPager: (params) => {
        return req.apiAxios("POST", '/business/extend/BExtendController/whale-security/updateViewPager', params)
    },
     // 学生投递普通作品到毕设
     deliverOpusToGraduation: (params) => {
        return req.apiAxios("POST", '/business/opus/BOpusController/whale-security/deliverOpusToGraduation', params)
    },
}
